import { createPortal } from "react-dom";
import { Play } from "lucide-react";

// Grades 1-3: one big tap before the first question so the browser allows sound; then questions are read automatically.
export default function StartGate({ lang = "en", onStart }) {
  return createPortal(
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-6" data-testid="start-gate">
      <button onClick={onStart} data-testid="start-gate-btn"
        className="nb-card bg-amber-300 border-4 border-slate-900 rounded-3xl px-10 py-8 flex flex-col items-center gap-3 font-kids text-slate-900 shadow-[6px_6px_0_0_#0F172A] active:translate-x-1 active:translate-y-1 transition-transform">
        <span className="w-24 h-24 rounded-full bg-white border-4 border-slate-900 flex items-center justify-center">
          <Play size={48} className="ml-1" />
        </span>
        <span className="text-4xl font-bold">{lang === "fr" ? "Commencer" : "Start"}</span>
        <span className="text-2xl font-bold">Kumanse</span>
      </button>
    </div>,
    document.body,
  );
}
